import { GenericIcon } from '../GenericIcon/GenericIcon';
import { getIconProductType } from '../GenericIcon/types';
import { useAppOrientation } from '@/lostHooks/orientation/useOrientation';
import { sendAndroidWrapperEvent } from '@/utilities/helpers/wrapperHelpers';
import { ANDROID_WRAPPER_EVENTS } from '@/event-manager/types';
import { presentResponsiblePlaySettings } from '@/unified-modules/rg/rg-library';
import { PLATFORMS } from '@/utilities/constants/game';
import { useStore } from '@/store/useStore';
import { useShallow } from 'zustand/react/shallow';

export default function GameWindowFooter() {
  const orientation = useAppOrientation();
  const { showLogo, showResponsibleGaming, responsibleGamingLink } = useStore(
    useShallow((s) => s.commonUIContext),
  );

  const platform = useStore((s) => s.runtime.platform);
  const wrapperType = useStore(useShallow((s) => s.runtime.wrapperType));

  const handleRGClick = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    if (platform === PLATFORMS.Desktop || platform === PLATFORMS.MobileWeb) {
      e.preventDefault();
      void presentResponsiblePlaySettings();
      return;
    }

    if (wrapperType.isXsell) {
      e.preventDefault();
      sendAndroidWrapperEvent(
        ANDROID_WRAPPER_EVENTS.OPEN_EXTERNAL_WEBVIEW,
        responsibleGamingLink,
      );
      return;
    }
  };

  return (
    <div className="slot footer-group">
      {showResponsibleGaming && (
        <a
          href={responsibleGamingLink}
          rel="noreferrer"
          target="_blank"
          className="footer-rg"
          data-testid="responsible-gaming-footer-button"
          onClick={handleRGClick}
        >
          <GenericIcon
            type="responsible_gambling"
            subtype={'terms'}
            product={getIconProductType()}
          />
        </a>
      )}
      {showLogo && (
        <div className="footer-icon">
          <GenericIcon
            type="logo"
            subtype={orientation === 'landscape' ? 'landscape' : 'default'}
            product={getIconProductType()}
          />
        </div>
      )}
    </div>
  );
}
